import { defineMessages } from 'react-intl';

export default defineMessages({
    wtTypeOfIncident: {
        id: 'fnol.wt.views.wt-claim-type.Type of Incident',
        defaultMessage: 'Type of Incident'
    }
});
